export let isHuntPlannerDisable = (action) => {
  return {
    type: 'IS_HUNTPLANNER_DISABLE'
  }
}

export let isHuntPlannerEnable = (action) => {
  return {
    type: 'IS_HUNTPLANNER_ENABLE'
  }
}
